var React = require('react');

function Abonnement (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 2L15.1862 8.2548L22 9.25673L17 14.1258L18.25 21L12 17.7548L5.75 21L7 14.1258L2 9.25673L9 8.2548L12 2Z","fill":"currentColor"}));
}

Abonnement.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Abonnement;

Abonnement.default = Abonnement;
